import { render, staticRenderFns } from "./subsidy.vue?vue&type=template&id=1338d9d4&scoped=true&"
import script from "./subsidy.vue?vue&type=script&lang=js&"
export * from "./subsidy.vue?vue&type=script&lang=js&"
import style0 from "./subsidy.vue?vue&type=style&index=0&id=1338d9d4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1338d9d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1338d9d4')) {
      api.createRecord('1338d9d4', component.options)
    } else {
      api.reload('1338d9d4', component.options)
    }
    module.hot.accept("./subsidy.vue?vue&type=template&id=1338d9d4&scoped=true&", function () {
      api.rerender('1338d9d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/event1/components/subsidy.vue"
export default component.exports